import { useIsMobile } from "../../hooks/useIsMobile";
import { MakesUsDifferentCategories } from "./WhatMakesUsDifferent/WhatMakesUsDifferent";
import "./MakesUsDifferentCategorySelector.css";

interface DifferentCategorySelectorProps {
  categories: readonly MakesUsDifferentCategories[];
  selectedCategory: MakesUsDifferentCategories;
  setSelectedCategory: (category: MakesUsDifferentCategories) => void;
}

const MobileCategorySelector: React.FC<DifferentCategorySelectorProps> = ({
  categories,
  selectedCategory,
  setSelectedCategory,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as MakesUsDifferentCategories;
    if (categories.includes(value)) {
      setSelectedCategory(value);
    }
  };

  return (
    <select
      value={selectedCategory}
      onChange={handleChange}
      className="homepage-wmud-mobile-form-select homepage-wmud-mobile-dropdown"
    >
      {categories.map((category) => (
        <option key={category} value={category}>
          {category}
        </option>
      ))}
    </select>
  );
};

const DesktopCategorySelector: React.FC<DifferentCategorySelectorProps> = ({
  categories,
  selectedCategory,
  setSelectedCategory,
}) => {
  return (
    <div className="homepage-wmud-category-desktop-selector">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => setSelectedCategory(category)}
          className={`homepage-wmud-category-btn ${
            selectedCategory === category ? "selected" : ""
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};
const WhatMakesUsDifferentCategorySelector: React.FC<
  DifferentCategorySelectorProps
> = ({ categories, selectedCategory, setSelectedCategory }) => {
  const isMobile = useIsMobile();
  return isMobile ? (
    <MobileCategorySelector
      categories={categories}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
    />
  ) : (
    <DesktopCategorySelector
      categories={categories}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
    />
  );
};

export default WhatMakesUsDifferentCategorySelector;
